<template>
  <main class="home">
    <section id="intro" v-html="home.text"></section>
    <info></info>
    <programm></programm>
    <curators></curators>
    <press></press>
    <partners></partners>
    <kontakt></kontakt>
  </main>
</template>

<script>
import Programm from './Programm.vue'
import Info from './Info.vue'
import Curators from './Kuratorium.vue'
import Press from './Press.vue'
import Partners from './Partners.vue'
import Kontakt from './Kontakt.vue'

export default {
  name: 'home',
  components: {
    Programm,
    Info,
    Curators,
    Press,
    Partners,
    Kontakt
  },
  computed: {
    home () {
      return this.$store.getters.getPageByUID('home')
    },
    festival () {
      return this.$store.getters.getPageByUID('festival')
    }
  },
  data () {
    return {
    }
  }
}
</script>

<style lang="scss">
@import '../assets/styles/base';

</style>
